import errorManager from '@/rollbar.js';

const initMoment = () => {
  moment.locale(window.locale);
};

const initVersioningSection = () => {
  if (!$('.js-versioning-section').length) {
    return false;
  }

  window.versioningSection.init();

  eventBus.$on('loadingReady::init-js-form', (data) => {
    Loader.show();
    eventBus.$emit(`reloadOriginalState`);
  });
};

const initConcurrency = () => {
  if (!$('.js-main-form').length) {
    return false;
  }

  eventBus.$on('loadingReady::init-js-form', (data) => {
    Loader.show();
    eventBus.$emit(`reloadOriginalState`);
  });
};

const asyncViewLoading = () => {
  eventBus.$on('loadingReady::reload-js-form', (data) => {
    Loader.show();
    eventBus.$emit(`reloadOriginalState`, data);
  });
};

const waitingForm = (waitEvent = 'init-js-form', area = '.js-main-form', data = null) => {
  window.loading.init({
    wrapper: '.main--container',
    area: '.js-main-form',
    waitEvent,
    dataToSend: data,
    DOMFromNestedVue: true,
  });
};

const initTableAsync = () => {
  $('.table-activator').on('click', (e) => {
    const current = e.target?.getAttribute('data-activator-table');

    if (current) {
      eventBus.$emit(`refreshComponent::table::${current}`);
      e.target.removeAttribute('data-activator-table');
    }
  });
};

const initViewLoading = () => {
  eventBus.$on('newViewLoaded', (data) => {
    const { response, content } = data;
    document.querySelector(content.append_to).innerHTML = response;
    window.updateVueInstances();
    window.DatePKR.init();
    window.VersionAttribute.init();
    window.CreateSelect2.init();
    window.RichTextEditor.init(); // provvisorio per fixare hobbies
    if (content.tab == 'tab_anamnesis') {
      window.Select2SelectAll.init('#allergies_id', '#all_visible');
      window.allergieNonRiferite.init('.js_allergie_non_riferite');
    }
    waitingForm('reload-js-form', content.append_to, { asyncArea: content.append_to });
  });
};

const initComponentsModules = () => {
  initVersioningSection();
  initConcurrency();
  asyncViewLoading();
  waitingForm();
  initMoment();
  initTableAsync();
  initViewLoading();
};

const setObserver = () => {
  initComponentsModules();
};

const init = () => {
  try {
    setObserver();
  } catch (e) {
    errorManager(e);
  }
};

window.globalScope = {
  init,
};
